import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from '../../lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'DateTimePickerLazy',
        path: () => path.join(__dirname, './DateTimePicker'),
        resolve: () => require.resolveWeak('./DateTimePicker'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "DateTimePickerLazy" */ './DateTimePicker'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
